import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

import { colors } from "@/theme/tokens/colors";

export const StepIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon sx={{ width: "65px", height: "65px" }} {...props}>
    <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="63" height="63" rx="31.5" stroke={colors.brand.blue} />
      <path
        d="M45.5 24.3999L27.625 42.5999L19.5 34.3272"
        stroke={colors.brand.blue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
